export enum InvoiceErrorStatusEnum {
  Failed = 'failed',
  ActionRequired = 'action_required',
  Cancelled = 'cancelled',
}

export const invoiceErrorStatusLocoKeys = {
  [InvoiceErrorStatusEnum.Failed]:
    'dashboard.affiliate.state.invoice_details.invoice_error_status.failed',
  [InvoiceErrorStatusEnum.ActionRequired]:
    'dashboard.affiliate.state.invoice_details.invoice_error_status.action_required',
  [InvoiceErrorStatusEnum.Cancelled]:
    'dashboard.affiliate.state.invoice_details.invoice_error_status.cancelled',
}
